import { render } from "./TranslationPanel.vue?vue&type=template&id=3a0b3850&scoped=true"
import script from "./TranslationPanel.vue?vue&type=script&lang=ts"
export * from "./TranslationPanel.vue?vue&type=script&lang=ts"

import "./TranslationPanel.vue?vue&type=style&index=0&id=3a0b3850&lang=scss&scoped=true"
import "./TranslationPanel.vue?vue&type=style&index=1&id=3a0b3850&lang=scss"
script.render = render
script.__scopeId = "data-v-3a0b3850"

export default script